import { render, staticRenderFns } from "./MobileLoading.vue?vue&type=template&id=134b3878&scoped=true&"
import script from "./MobileLoading.vue?vue&type=script&lang=js&"
export * from "./MobileLoading.vue?vue&type=script&lang=js&"
import style0 from "./MobileLoading.vue?vue&type=style&index=0&id=134b3878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b3878",
  null
  
)

export default component.exports